import { render, staticRenderFns } from "./ListB.vue?vue&type=template&id=91fa032a&scoped=true&"
import script from "./ListB.vue?vue&type=script&lang=js&"
export * from "./ListB.vue?vue&type=script&lang=js&"
import style0 from "./ListB.vue?vue&type=style&index=0&id=91fa032a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fa032a",
  null
  
)

export default component.exports